import TicketProgressBar from "./TicketProgressBar";
export default TicketProgressBar;
